// Pick a fitting Ionicons name for an app's Discover listing, so published apps don't all
// show a generic cube. Heuristic: keyword-match the name/description first (most reliable),
// else the first NON-generic navigation icon, else a neutral fallback. Pure + unit-tested.

interface IconSource {
  name?: string;
  description?: string;
  navigation?: { screens?: { icon?: string }[] };
}

// Nav icons that describe navigation, not the app's subject — skip these when borrowing.
const GENERIC_NAV = /^(home|list|menu|grid|apps|settings|today|star|ellipsis|add|search|person|people|information|help)(-outline)?$/i;

const KEYWORD_ICON: [RegExp, string][] = [
  [/\b(ski|resort|snow|slope|powder|mountain|alpine)\b/i, 'snow'],
  [/\b(restaurant|menu|food|dish|cafe|café|eat|dining|osteria|bistro|trattoria|pizzeria|recipe|cook)\b/i, 'restaurant'],
  [/\b(barber|barbershop|haircut|salon|shave|fade|grooming)\b/i, 'cut'],
  [/\b(run|running|jog|jogging|marathon|pace|stride|5k|10k)\b/i, 'walk'],
  [/\b(workout|calisthenic|calisthenics|fitness|gym|exercise|training|reps|strength|muscle)\b/i, 'barbell'],
  [/\b(community|neighbor|neighbou?rhood|feed|social|local|meetup)\b/i, 'people-circle'],
  [/\b(book|reading|library|novel)\b/i, 'book'],
  [/\b(budget|expense|money|finance|spending|wallet)\b/i, 'wallet'],
  [/\b(habit|streak|routine)\b/i, 'checkmark-circle'],
  [/\b(travel|trip|itinerary|flight|vacation)\b/i, 'airplane'],
  [/\b(music|song|playlist|album)\b/i, 'musical-notes'],
  [/\b(photo|gallery|album|camera)\b/i, 'images'],
  [/\b(event|calendar|schedule|booking|appointment|reservation)\b/i, 'calendar'],
  [/\b(shop|store|product|listing|market)\b/i, 'pricetag'],
  [/\b(health|medical|wellness|meditat)\b/i, 'heart'],
];

export function pickAppIcon(def: IconSource): string {
  const text = `${def.name ?? ''} ${def.description ?? ''}`;
  for (const [re, icon] of KEYWORD_ICON) if (re.test(text)) return icon;

  const navIcon = (def.navigation?.screens ?? [])
    .map((s) => s.icon)
    .find((i): i is string => !!i && !GENERIC_NAV.test(i));
  if (navIcon) return navIcon.replace(/-outline$/, '');

  return 'cube-outline';
}
